export default "__VITE_ASSET__CE33C8ov__"